export default __webpack_public_path__ + "static/media/changePass.be232e43.svg";